import React, { useEffect, useRef, useState } from 'react';
import './index.scss';
import MapOperations, {
  transformLocationWgs84toGcj02,
} from '@/utils/MapOperations';
import { MapLayerEnum } from '@/utils/enum';
import CollectMapApi from '@/fetch/bussiness/collectMap';
import { HttpStatusCode } from '@/fetch/core/constant';
import {
  addGlobalEventListener,
  removeGlobalEventListener,
} from '@/utils/emit';
import StandardTileMap from '@/components/StandardTileMap';
import { isEmpty } from '@/utils/util';

const TravelRoutes = ({
  show,
  taskId,
  vehicleName,
  latitude,
  longitude,
  rotation,
  zoom,
  collectionStatus,
}: {
  show: boolean;
  taskId: number | string;
  vehicleName: string;
  latitude: number;
  longitude: number;
  rotation: number;
  zoom?: number;
  collectionStatus?: string;
}) => {
  const fetchApi = new CollectMapApi();
  const mapRef = useRef<any>(null); // 地图实例
  const mapOperateRef = useRef<any>(null); // 地图操作方法的类的实例
  const travelOperateRef = useRef<any>(null); // 行驶轨迹操作方法的类的实例
  const [finished, setFinished] = useState<any[][]>([[]]);

  useEffect(() => {
    if (mapRef.current && !travelOperateRef.current) {
      travelOperateRef.current = new MapOperations(mapRef.current);
    }
  }, [longitude, latitude]);

  useEffect(() => {
    const cb = () => {
      mapOperateRef.current &&
        mapOperateRef.current?.clearLayer(MapLayerEnum.TRAVEL_ROUTE_LAYER);
    };
    mapOperateRef.current &&
      addGlobalEventListener('click_finish_collect_btn', cb);
    return () => {
      removeGlobalEventListener('click_finish_collect_btn', cb);
    };
  }, [mapOperateRef.current]);

  useEffect(() => {
    if (show) {
      getFinishedRoutes();

      // 当组件显示时，确保地图正确调整大小
      if (mapRef.current) {
        setTimeout(() => {
          mapRef.current.updateSize();
        }, 300);
      }
    }
  }, [show]);

  useEffect(() => {
    if (travelOperateRef.current) {
      travelOperateRef.current?.updateRealTimePosition(
        [longitude, latitude],
        rotation
      );
      const isPaused = collectionStatus !== 'PROCESSING';
      setFinished((prev) => {
        if (!Array.isArray(prev) || prev.length === 0) {
          return [[{ longitude, latitude }]];
        }
        if (isPaused) {
          return [...prev, [{ longitude, latitude }]];
        } else {
          const lastSegment = prev[prev.length - 1];
          return [
            ...prev.slice(0, -1),
            [...lastSegment, { longitude, latitude }],
          ];
        }
      });
    }
  }, [latitude, longitude, travelOperateRef.current, collectionStatus]);

  useEffect(() => {
    travelOperateRef.current &&
      travelOperateRef.current?.updateTravelPath(finished);
  }, [finished, travelOperateRef.current]);

  const getFinishedRoutes = async () => {
    const res = await fetchApi.getFinishedRoute({ taskId, vehicleName });
    if (res.code === HttpStatusCode.Success) {
      if (!isEmpty(res.data?.finishedPointList)) {
        const parsedFinishedRoutes = res.data?.finishedPointList?.map(
          (segment: any[]) =>
            segment.map((point: any) => {
              const [longitude, latitude] = transformLocationWgs84toGcj02([
                point.longitude,
                point.latitude,
              ]);
              return { longitude, latitude };
            })
        );
        setFinished(parsedFinishedRoutes);
        const temp = res.data?.finishedPointList[0][0];
        const [longitude, latitude] = transformLocationWgs84toGcj02([
          temp.longitude,
          temp.latitude,
        ]);
        travelOperateRef.current?.drawStartPoint([longitude, latitude]);
      } else {
        setFinished([]);
      }
    }
  };

  return (
    <StandardTileMap
      latitude={latitude}
      longitude={longitude}
      zoom={zoom}
      getMapRef={(ref) => (mapRef.current = ref)}
    />
  );
};

export default React.memo(TravelRoutes);
